
function convertTrelloCommentsToTchat(comments) {
  return comments.map(c => ({
      author: c.author.fullName,
      authorId: c.author.idSdc,
      date: c.date + " " + c.hour,
      comment: c.text
    })
  );
}

export default { convertTrelloCommentsToTchat };
export { convertTrelloCommentsToTchat };



// WEBPACK FOOTER //
// ./src/helpers/trelloCustomMessageToTchatConverter.js